import { Link } from 'react-router-dom';
import DramaCard from '@/components/base/DramaCard';
import { getLatestUpdates } from '@/utils/drama';

export default function LatestUpdates() {
  const list = getLatestUpdates(8);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
              <i className="ri-refresh-line text-primary-500"></i>
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-600">追更不停，看看刚刚更新的剧集</p>
          </div>
          <Link
            to="/category?sort=update"
            className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-5">
          {list.map((drama, i) => (
            <DramaCard key={drama.id} drama={drama} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}